// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Labels = require("../../reason/clients/components/Labels.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let UTCDate = require("../../reason/common/types/UTCDate.bs.js");
let DateFns = require("date-fns");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let OwnForSalePropertyStatusLabel_forSalePropertyV5_graphql = require("../../__generated__/OwnForSalePropertyStatusLabel_forSalePropertyV5_graphql.bs.js");

let convertFragment = OwnForSalePropertyStatusLabel_forSalePropertyV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, OwnForSalePropertyStatusLabel_forSalePropertyV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(OwnForSalePropertyStatusLabel_forSalePropertyV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, OwnForSalePropertyStatusLabel_forSalePropertyV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(OwnForSalePropertyStatusLabel_forSalePropertyV5_graphql.node, convertFragment, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function OwnForSalePropertyStatusLabel$WithoutErrorBoundary(props) {
  let match = RescriptRelay_Fragment.useFragment(OwnForSalePropertyStatusLabel_forSalePropertyV5_graphql.node, convertFragment, props.forSaleProperty);
  let status = match.status;
  let isArchived;
  switch (status.__typename) {
    case "ActiveProperty" :
    case "__unselected" :
      isArchived = false;
      break;
    default:
      isArchived = status.archived;
  }
  if (isArchived) {
    return JsxRuntime.jsx(Labels.ArchivedLabel.make, {});
  }
  switch (status.__typename) {
    case "ActiveProperty" :
      if (!status.isRenewable) {
        return JsxRuntime.jsx(Labels.ActiveStatusLabel.make, {});
      }
      let daysLeft = DateFns.differenceInCalendarDays(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(status.activeUntil)), new Date());
      return JsxRuntime.jsx(Labels.ExpiringStatusLabel.make, {
        expiringIn: Labels.stringOfExpiring(daysLeft)
      });
    case "ExpiredProperty" :
      return JsxRuntime.jsx(Labels.ExpiredStatusLabel.make, {});
    case "SoldProperty" :
      return JsxRuntime.jsx(Labels.SoldLabel.make, {});
    case "UnderContractProperty" :
      return JsxRuntime.jsx(Labels.UnderContractLabel.make, {});
    case "WithdrawnProperty" :
      return JsxRuntime.jsx(Labels.WithdrawnLabel.make, {});
    case "__unselected" :
      return null;
  }
}

let WithoutErrorBoundary = {
  make: OwnForSalePropertyStatusLabel$WithoutErrorBoundary
};

function OwnForSalePropertyStatusLabel(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "property status",
    children: JsxRuntime.jsx(OwnForSalePropertyStatusLabel$WithoutErrorBoundary, {
      forSaleProperty: props.forSaleProperty
    })
  });
}

let make = OwnForSalePropertyStatusLabel;

exports.PropertyFragment = PropertyFragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Labels Not a pure module */
